import { LS_LANGUAGE_KEY } from "../../i18n";

const LS_AUTH_TOKEN_KEY = "TOKEN";

export const getApiToken = (): string | null => {
  return localStorage.getItem(LS_AUTH_TOKEN_KEY);
};

export const setApiToken = (token: string): void => {
  return localStorage.setItem(LS_AUTH_TOKEN_KEY, token);
};

export const expireApiToken = (): void => {
  return localStorage.removeItem(LS_AUTH_TOKEN_KEY);
};

export const getLanguage = (): string | null => {
  return localStorage.getItem(LS_LANGUAGE_KEY);
};
